import { ResendInvitationDialogProps } from "@/app/settings/club/components/invitation/type"
import Dialog from "@/components/dialog/Dialog"
import { useTranslation } from "react-i18next"

export default function InvitationActionDialog({ ...props }: ResendInvitationDialogProps) {
  const { t } = useTranslation("")

  return <Dialog maxWidth="400px" title={t("confirm")} {...props}></Dialog>
}
